module.exports = __webpack_public_path__ + "static/media/error.db790150.svg";